import React from 'react';
import InputField from '../../../Forms/Input/InputField';

interface BankTransferPaymentSectionProps {
  voucherCode: string;
  onVoucherChange: (value: string) => void;
}

const BankTransferPaymentSection: React.FC<BankTransferPaymentSectionProps> = ({
  voucherCode,
  onVoucherChange,
}) => {
  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    onVoucherChange(e.target.value);
  };

  return (
    <div className="grid gap-4 sm:grid-cols-2">
      <InputField
        label="Referencia de Transferencia"
        name="bankTransferVoucher"
        iconKey="transfer"
        type="text"
        placeholder="Ingrese la referencia de la transferencia"
        value={voucherCode}
        onChange={handleChange}
      />
    </div>
  );
};

export default BankTransferPaymentSection;
